module.exports = __webpack_public_path__ + "img/home_core_icon_bj.f758a3c4.png";